import Dashboard from "@/pages/Dashboard/index.vue";
import auth from "../middleware/authMiddleware.js";

export default {
  path: "/dashboard",
  name: "Dashboard",
  component: Dashboard,
  meta: {
    middleware: [auth]
  }
};
